


























import {Component, Vue} from 'vue-property-decorator';
import MazeManager from './components/MazeManager.vue';
import AppFooter from '@/components/AppFooter.vue';
import AssetsList from '@/components/AssetsList.vue';

@Component({components: {AssetsList, AppFooter, MazeManager}})
export default class App extends Vue {
    private drawer: boolean = false;
}
